import {
  Button,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react"
import { useNavigate } from "@tanstack/react-router"

import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { type Item, ItemsService } from "../client"

const Catalog: React.FC = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const {
    data: services,
    error,
    isPending,
  } = useQuery({
    queryFn: () => ItemsService.readItems(),
    queryKey: ["services"],
  })

  useEffect(() => {
    queryClient.prefetchQuery({
      queryFn: () => ItemsService.readItems(),
      queryKey: ["services"],
    })
  }, [queryClient])

  if (isPending) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error loading services</div>
  }

  return (
    <>
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <Th>Add Service</Th>
            </Tr>
          </Thead>
          {isPending ? (
            <Tbody>
              <Tr>
                {new Array(1).fill(null).map((_, index) => (
                  <Td key={index}>
                    <SkeletonText noOfLines={1} paddingBlock="16px" />
                  </Td>
                ))}
              </Tr>
            </Tbody>
          ) : (
            <Tbody>
              {services?.data.map((service: Item) => (
                <Tr key={service.code}>
                  <Td maxWidth="300px">{service.name}</Td>
                  <Td>
                    <Button
                      onClick={() => {
                        const url = `/customize?item=${service.code}`
                        navigate({ to: url })
                      }}
                    >
                      Customize
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          )}
        </Table>
      </TableContainer>
    </>
  )
}

export default Catalog
